import React, { useState } from "react";
import { api } from "../api";
import { useLang } from "../i18n";
import { toast } from "sonner";
import { Stethoscope, ArrowUpRight, Send } from "lucide-react";

export function MdsBridge({ specialistUrl = "https://www.mdsmed.it" }) {
  const { t, lang } = useLang();
  const [open, setOpen] = useState(false);
  const [topic, setTopic] = useState("");
  const [message, setMessage] = useState("");
  const [phone, setPhone] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (message.trim().length < 3) return;
    setBusy(true);
    try {
      await api.post("/consultations", { topic, message, phone });
      setSent(true);
      toast.success(lang === "it" ? "Richiesta inviata!" : "Request sent!");
    } catch (e2) {
      toast.error("Errore");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mt-6 rounded-[1.5rem] p-6 bg-[#3F6E85] text-white" data-testid="mds-bridge">
      <div className="flex items-start gap-3">
        <span className="w-11 h-11 rounded-full bg-white/12 flex items-center justify-center shrink-0">
          <Stethoscope className="w-5 h-5 text-[#F0B27A]" />
        </span>
        <div className="flex-1">
          <h4 className="font-serif text-xl mb-1">{t("mds_title")}</h4>
          <p className="text-sm text-white/80 mb-4">{t("mds_sub")}</p>

          {sent ? (
            <p className="text-sm text-[#bfe3d2]" data-testid="mds-sent">{t("mds_sent")}</p>
          ) : open ? (
            <form onSubmit={submit} className="space-y-3" data-testid="mds-form">
              <input value={topic} onChange={(e) => setTopic(e.target.value)} data-testid="mds-topic"
                placeholder={t("mds_topic_ph")} className="w-full rounded-xl bg-white/95 text-[#1A1D20] px-4 py-2.5 text-sm focus-visible:ring-2 focus-visible:ring-[#E08A3C] outline-none" />
              <textarea value={message} onChange={(e) => setMessage(e.target.value)} required data-testid="mds-message"
                placeholder={t("mds_message_ph")} rows={3} className="w-full rounded-xl bg-white/95 text-[#1A1D20] px-4 py-2.5 text-sm focus-visible:ring-2 focus-visible:ring-[#E08A3C] outline-none resize-none" />
              <input value={phone} onChange={(e) => setPhone(e.target.value)} data-testid="mds-phone"
                placeholder={t("mds_phone_ph")} className="w-full rounded-xl bg-white/95 text-[#1A1D20] px-4 py-2.5 text-sm focus-visible:ring-2 focus-visible:ring-[#E08A3C] outline-none" />
              <div className="flex flex-wrap gap-3">
                <button type="submit" disabled={busy} data-testid="mds-submit"
                  className="inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-semibold bg-white text-[#3F6E85] hover:bg-[#FCFBF8] disabled:opacity-60 transition-colors">
                  <Send className="w-4 h-4" /> {busy ? "..." : t("mds_send")}
                </button>
                <a href={specialistUrl} target="_blank" rel="noopener noreferrer" data-testid="mds-link"
                  className="inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-semibold bg-white/10 hover:bg-white/20 transition-colors">
                  www.mdsmed.it <ArrowUpRight className="w-4 h-4" />
                </a>
              </div>
            </form>
          ) : (
            <div className="flex flex-wrap gap-3">
              <button onClick={() => setOpen(true)} data-testid="mds-open"
                className="inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-semibold bg-white text-[#3F6E85] hover:bg-[#FCFBF8] transition-colors">
                {t("mds_write_us")}
              </button>
              <a href={specialistUrl} target="_blank" rel="noopener noreferrer" data-testid="mds-link"
                className="inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-semibold bg-white/10 hover:bg-white/20 transition-colors">
                www.mdsmed.it <ArrowUpRight className="w-4 h-4" />
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
